import React, { Component } from 'react';
import { Input, Form,Row, Col, Modal, Button,Select, message } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../utils/ActionStatus';

const TextArea = Input.TextArea;
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 12 },
};
class CopUserAccessModalDialog extends Component {

    refreshQuery() {
        const {
            userName,
            status
        } = this.props.userAccessQueryFields;
        this.props.loadUserAccessInfo({userName, status})
    }

    componentDidUpdate() {
        const {
            copUserAccessStatus,
        } = this.props;
        if(copUserAccessStatus === ACTION_STATUS.SUCCESS) {
            message.success('CopAll User Access Info succeeded');
            this.props.initCopUserAccessActionStatus();
            this.props.resetCopUserAccessModal();
            this.refreshQuery();
        }
        if(copUserAccessStatus === ACTION_STATUS.ERROR) {
            this.props.initCopUserAccessActionStatus();
        }
    }


    onInputChange = ({name, value}) => {
        this.props.copUserAccessChangeInput({name, value});
    }


    submitCopUserAccess = () => {
        Modal.confirm({
            title: 'Are you sure copy access to select?',
            onOk: () => {
            
                const {
                    id,
                    employee,
                    comments,
                } = this.props.copUserAccessModal.fields;
                this.props.copUserAccess({id, employee, comments});
            },
            onCancel: () => {},
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            copUserAccessModal,
            copUserAccessStatus,
            userAccountOptions,
        } = this.props;
        const {
            isOpened,
            respErrMsg,
        } = copUserAccessModal;

        const {
            comments,
            employee,
        } = copUserAccessModal.fields

        const isSubmitLoading = copUserAccessStatus === ACTION_STATUS.LOGINING;
        

        return (
            <div>
                <Modal
                    title={'Copy ALL User Access Info'}
                    centered
                    width={500}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetCopUserAccessModal()}
                    footer={[
                        <Button key="back" onClick={() => this.props.resetCopUserAccessModal()}>
                          Close
                        </Button>,
                        <Button key="save" type="primary" loading={isSubmitLoading} onClick={this.submitCopUserAccess}>
                          Submit
                        </Button>,
                      ]}
                >
                <Row gutter={24}>
                    <Col span={12}>
                            <FormItem {...formItemLayout} label="Employee">
                            {getFieldDecorator('employee', {
                                initialValue: employee,
                                rules: [{
                                    required: true,
                                    message: 'Please select Employee',
                                }],
                                })(
                                <Select
                                        allowClear
                                        showSearch
                                        style={{ width: 200, marginLeft: 10 }}
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'employee', value: val })
                                        }} 
                                        placeholder="Please select Employee">
                                    {userAccountOptions}
                                </Select>
                                )}
                            </FormItem>
                    </Col>
                </Row> 
                <Row gutter={24}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Comments">
                        {getFieldDecorator('comments', {
                            initialValue: comments,
                            rules: [{
                                required: false,
                                message: 'Please input Comments',
                            }],
                            })(
                            <TextArea 
                                style={{ width: 200, marginLeft: 10 }}
                                rows={3} 
                                onChange={(e) => {
                                    this.onInputChange({ name: 'comments', value: e.target.value })
                                }}
                            />
                            )}
                        </FormItem>
                    </Col>
                </Row> 



                    {
                    !!respErrMsg &&  
                    <Message negative>
                        <Message.Header>Response Error Message</Message.Header>
                        <p>{ respErrMsg }</p>
                    </Message>
                    }
                </Modal>
                
            </div>
            
        );
    }

}

const CopUserAccessModalDialogForm = Form.create({ name: 'CopUserAccessModalDialog' })(CopUserAccessModalDialog);
export default CopUserAccessModalDialogForm;
